export enum APIKeys {
  GET_USER_INFO = '/questionai/user/userinfo', // 获取登录用户信息
  GET_CHAT_CONFIG = '/questionai/webchat/cfg', // 获取聊天配置
  CHAT_ACK = '/questionai/chat/ack', // 回复消息接收完确认
  CHAT_STOP = '/questionai/chat/stop', // 聊天暂停

  GET_QUESTION_DETAIL = '/qai/chatweb/questionDetail', // 获取题目详情
  GET_OCR_DETAIL = '/questionai/chat/ocr', // 获取ocr识别内容

  /**
   * 获取小论文、书评详情
   */
  GET_AIGC_DOCUMENT_DETAIL_BY_MESSAGE_ID = '/questionai/chat/gen-result',
  UPLOAD_DOC = '/questionai/doc/upload',
  /**
   * 获取由小论文、书评页面生成的PDF
   */
  GET_AIGC_DOCUMENT_PDF_FILE_BY_MESSAGE_ID = '/questionai/chat/get-gen-pdf',
  GET_FILL_CODE = '/questionai/activity/fillCode',

  /**
   * 整本书-搜索
   */
  SEARCH_TEXTBOOK = '/questionai/textbook/search',
  /**
   * 整本书-学科列表
   */
  GET_SUBJECT_LIST_IN_TEXTBOOK = '/questionai/textbook/subject/list',
  /**
   * 整本书-教材列表（带分页）
   */
  GET_TEXTBOOK_LIST_WITH_PAGE = '/questionai/textbook/v2/list',
  /*
   * 获取QEM详情
   */
  GET_QEM_DETAIL = '/questionai/sem/materialDetail',
  /**
   * 获取用户资源位配置
   */
  GET_USER_PLACEMENT = '/questionai/adplacement/getuseractivity',
  /**
   * 公共枚举
   */
  GET_COMMON_ENUM = '/questionai/common/enum',
  /**
   * 设置用户学段
   */
  SET_USER_STAGE = '/questionai/user/setStage',
  /**
   * 按学校名称模糊搜索学校列表
   */
  GET_SCHOOL_LIST_BY_KEYWORD = '/questionai/school/search',
  /**
   * 按学校、课程名称模糊搜索课程列表
   */
  GET_COURSE_LIST_BY_SCHOOL_AND_KEYWORD = '/questionai/school/searchCourse',
  /**
   * 用户反馈
   */
  USER_FEEDBACK = '/questionai/user/feedback',
  RECOMMAND_SCHOOLS = '/questionai/school/location',
}

/**
 * 频繁访问code
 */
export enum ErrNoKeys {
  forbidden = 6000,
  frequent = 6001,
  expired = 6012,
}
